import faker from 'faker'
import gravyAxios from "@/plugins/axios";

const emailSettingsStore = {
    state: () => ({
        previewSignature: null,
        emailSettings: [],
        emailSetting: null,
    }),
    actions: {
        previewSignature: async ({commit}, previewSignature) => {
            let response = await gravyAxios.post('/template/try', previewSignature)
            commit('SET_PREVIEW_SIGNATURE', response.data)
        },
        getEmailSettings: async ({commit, getters}, clientId) => {
            let emailSettings = await gravyAxios.get(`/emailsettings/${clientId}`)
            commit('SET_EMAIL_SETTINGS', emailSettings.data)
        },
        getEmailSetting: async ({commit }, emailSetting) => {
            let emailSettingFetched = await gravyAxios.get(`/emailsetting/${emailSetting.id}`)
            commit('SET_EMAIL_SETTING', emailSettingFetched.data)
        },
        createEmailSetting: async ({commit}, emailSetting) => {
            let newEmailSetting = await gravyAxios.post('/emailsetting', emailSetting)
            await commit('NEW_EMAIL_SETTING', newEmailSetting.data)
        },
        updateEmailSetting: async ({commit}, emailSetting) => {
            let updatedEmailSetting = await gravyAxios.patch('/emailsetting', emailSetting)
            await commit('UPDATE_EMAIL_SETTING', updatedEmailSetting.data)
        },
        deleteEmailSetting: async ({commit}, emailSetting) => {
            let deleted = await gravyAxios.delete(`/emailsetting/${emailSetting.id}`)
            await commit('DELETE_EMAIL_SETTING', emailSetting.id)
        },
        resetEmailSettings: ({commit}) => {
            commit('RESET_EMAIL_SETTINGS')
        }
    },
    mutations: {
        NEW_EMAIL_SETTING: (state, emailSetting) => {
            state.emailSettings.push(emailSetting)
        },
        DELETE_EMAIL_SETTING: (state, emailSettingId) => {
            const index = state.emailSettings.findIndex(es => es.id === emailSettingId)
            if (index !== -1) state.emailSettings.splice(index, 1)
        },
        UPDATE_EMAIL_SETTING: (state, emailSetting) => {
            const index = state.emailSettings.findIndex(es => es.id === emailSetting.id)
            if (index !== -1) state.emailSettings.splice(index, 1, emailSetting)
        },
        SET_EMAIL_SETTING: async (state, emailSetting) => {
            state.emailSetting = emailSetting
        },
        SET_EMAIL_SETTINGS: async (state, emailSettings) => {
            if (!emailSettings) return
            state.emailSettings = emailSettings
        },
        SET_PREVIEW_SIGNATURE: async (state, signature) => {
            state.previewSignature = signature
        },
        CLEAR_ACTIVE_EMAIL_SETTING: state => {
            state.emailSetting = null
        },
        RESET_EMAIL_SETTINGS: state => {
            state.emailSettings = []
        }

    },
    getters: {
        getEmailSettings: state => {
            return state.emailSettings
        },
        getEmailSetting: state => {
            return state.emailSetting
        },
        getEmailSettingsByClientId: (state) =>  (clientId) => {
            let test =  state.emailSettings.find(emailSetting => emailSetting.clientId === clientId)
            return test
        },
        getPreviewSignature: state => {
            return state.previewSignature
        }
    }
}

export default emailSettingsStore
